import {
  AccountLicenseEntitlementsEntity,
  LicenseAccessKeys,
  LicenseLimitKeys,
  LicenseLimitTypes,
} from "./license.types";

const assertNever = (_: never): never => {
  throw Error("Unhandled switch case");
};

// This has all the limits that are on a license PLUS some additional ones
// that are not on a license but are used in the app

const NonLicenseLimitTypes = ["manual::sections"] as const; // Maximum number of sections in a manual
type NonLicenseLimitKeys = (typeof NonLicenseLimitTypes)[number];

type LimitKeys = LicenseLimitKeys | NonLicenseLimitKeys;

function isLicenseLimitKey(key: string): key is LicenseLimitKeys {
  return LicenseLimitTypes.includes(key as LicenseLimitKeys);
}
function isNonLicenseLimitKey(key: string): key is NonLicenseLimitKeys {
  return NonLicenseLimitTypes.includes(key as NonLicenseLimitKeys);
}

export function getLimitFor(
  key: LimitKeys,
  license: AccountLicenseEntitlementsEntity
) {
  const licenseLimits = license.entitlements.limits;
  if (isLicenseLimitKey(key)) {
    // This is a license limit
    const limit = licenseLimits[key as LicenseLimitKeys];
    if (limit !== undefined) {
      return limit;
    }
    return 0; // Default to 0 if not found
  } else if (isNonLicenseLimitKey(key)) {
    // Hardcoded limits
    switch (key) {
      case "manual::sections":
        return 200; // Maximum number of sections in a manual
      default:
        assertNever(key);
        console.log(`Limit key ${key} not found in limits. Using 0.`);
        return 0;
    }
  }
  return 0;
}

export function hasAccessTo(
  key: LicenseAccessKeys,
  license: AccountLicenseEntitlementsEntity
) {
  const accessTypes = license.entitlements.accessTypes;
  if (accessTypes.includes(key)) {
    return true;
  }
  return false;
}
